import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
// core components
import { useState } from "react";
import { useQuery } from "react-query";
import Tooltip from "@mui/material/Tooltip";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";
import { ExternalLink } from "react-external-link";
import { Box } from '@mui/material';
import axios from "axios";
import { QueryClient } from "react-query";
import { queryClient } from "index.js";
import DeleteIcon from "@mui/icons-material/Delete";
// import { Alert } from '@mui/material';
import Divider from "@mui/material/Divider";
import RestoreIcon from "@mui/icons-material/Restore";
import FailureIcon from "@mui/icons-material/Cancel";
import SuccessIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import { DialogTitle } from '@mui/material';
import { Dialog } from '@mui/material';
import { DialogContent } from '@mui/material';
import { DialogContentText } from '@mui/material';
import { DialogActions } from '@mui/material';
import { green, red } from "@mui/material/colors";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";
import Button from "components/CustomButtons/Button.js";
import Alert from "components/CustomAlerts/Alert.js";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import PrettyBytes from "react-pretty-bytes";
import { getApiCall } from "hooks/axios";

export default function CompleteBackupTable(props) {
  const url = "/api/v1/backup/backups";
  const deleteUrl = "/api/v1/backup/backups";
  const restoreUrl = "/api/v1/backup/restores";
  const nfsUrl = "/api/v1/backup/nfsstatus";
  const [token, setToken] = useToken();
  const [open, setOpen] = React.useState(true);
  const [backupResponse, setBackupResponse] = React.useState(false);
  const [severity, setSeverity] = React.useState("error");
  const [backupMsg, setBackupMsg] = React.useState("Error loading backup data");
  const [restoredFile, setRestoredFile] = useState("");
  const [isCreatingBackup, setIsCreatingBackup] = useState(false);
  const [anchorElPop, setAnchorElPop] = React.useState(null);
  const openRestorePop = Boolean(anchorElPop);
  const [backupFile, setBackupFile] = useState("");
  const [backupElPop, setBackupElPop] = React.useState(null);
  const openCatchUpPop = Boolean(backupElPop);
  const [deleteElPop, setDeleteElPop] = React.useState(null);
  const openDeletePop = Boolean(deleteElPop);
  const [label, setLabel] = useState("Update a Backup");
  const [catchUpDesc, setCatchUpDesc] = useState("");

  useAxiosAuth(token);

  function handleCatchUpandRestore(e, name, status) {
    e.preventDefault();
    setLabel("Sync a Backup");
    setCatchUpDesc(
      "The sync function will update files in the backup to the current versions of those files. Older versions of files will be overwritten. "
    );
    if (status == "unknown" || status == "failed") {
      setLabel("Retry Backup Procedure");
      setCatchUpDesc(
        "This operation will re-try the backup procedure in the case it has failed or is in an unknown state. "
      );
    }
    setBackupFile(name);
    openCatchUpPopover(e);
  }

  const CatchUpButton = ({ status, name }) => (
    <Tooltip
      title={status == "unknown" || status == "failed" ? "Retry" : "Sync"}
      placement="top"
    >
      <label htmlFor="backup">
        <Button
          className="btn-choose"
          component="span"
          //  color="secondary"
          size="small"
          onClick={(e) => {
            e.preventDefault();
            handleCatchUpandRestore(e, name, status);
          }}
          style={{ width: "100px" }}
        >
          {status == "unknown" || status == "failed" ? "Retry" : "Sync"} &nbsp;
        </Button>
      </label>
    </Tooltip>
  );

  const DeleteButton = ({ name }) => (
    <MDTypography
      component={ExternalLink}
      href="#"
      variant="body2"
      color="info"
      onClick={(e) => {
        e.preventDefault();
        setBackupFile(name);
        openDeletePopover(e);
      }}
    >
      <Tooltip title="Delete" placement="top">
        <DeleteIcon fontSize="medium" />
      </Tooltip>
    </MDTypography>
  );
  const RestoreButton = ({ name }) => (
    <MDTypography
      component={ExternalLink}
      href="#"
      variant="body2"
      color="info"
      onClick={(e) => {
        e.preventDefault();
        setRestoredFile(name);
        openRestorePopover(e);
      }}
    >
      <Tooltip title="Restore" placement="top">
        <RestoreIcon fontSize="medium" />
      </Tooltip>
    </MDTypography>
  );

  const RestoreDisableButton = () => (
    <MDTypography href="#" variant="body2" color="secondary">
      <RestoreIcon fontSize="medium" />
    </MDTypography>
  );

  const restoreColumns = [
    { Header: "", accessor: "icon", width: "1px" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Start", accessor: "start", align: "left" },
    { Header: "End", accessor: "end", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
  ];
  const columns = [
    {
      Header: "Name",
      accessor: "name1",
      width: "1px",
    },
    {
      Header: "Name",
      accessor: "name",
      width: "10%",
      align: "left",
      isSorted: true,
    },
    {
      Header: "Last Modified",
      accessor: "lastsync",
      width: "20%",
      align: "left",
    },
    { Header: "Size", accessor: "size", width: "10%", align: "center" },
    { Header: "Status", accessor: "status", width: "15%", align: "center" },
    { Header: "Restore", accessor: "restore", width: "15%", align: "center" },
    { Header: "Delete", accessor: "delete", width: "15%", align: "center" },
    { Header: "Update", accessor: "update", width: "15%", align: "center" },
  ];

  const nfsData = useQuery(
    "nfs",
    async () => await getApiCall(nfsUrl, {
      onError: function(error) {
        // handle error
      }
    }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const nfsStatus = (nfsData.data != undefined && nfsData.data.available)  ?  nfsData.data.path : false;
  const refetchValue = nfsStatus ? 10000 : false;
  const enableApi = nfsStatus ? true : false;

  const { isLoading, error, data } = useQuery(
    "completebackup",
    async () => await getApiCall(url, {
      onError: function(e) {
        if(e.hasOwnProperty('response') && e.response.hasOwnProperty('data') && e.response.data.status === 403){
          const response = e.response.data
          if(response.errors && response.errors.length > 0) {
            handleBackupResponse(false, true, true);
            handleBackupMsg("error", response.errors[0].additional_info);
          } else {
            handleBackupResponse(false, true, true);
            handleBackupMsg("error", 'Incorrect NFS export configuration or incompatible NFS server.');
          }
        }
       
      }
    }),
    {
      enabled :  enableApi,
      refetchInterval: refetchValue,
    }
  );

  const restoreResult = useQuery(
    "restore",
    async () => await getApiCall(restoreUrl, {
      onError: (error) => {
        //handle error
      }
    }),
    {
      enabled :  enableApi,
      refetchInterval:  refetchValue,
    }
  );


  const createBackUp = async (event) => {
    setIsCreatingBackup(true);
    handleBackupResponse(true, true, true);
    handleBackupMsg("info", "Creating backup!");
    const backupResponse = await handleBackup(event);
  };

  const handleBackupResponse = (bkupCreation, bkupRes, setopen) => {
    setIsCreatingBackup(bkupCreation);
    setBackupResponse(bkupRes);
    setOpen(setopen);
  };
  const handleBackupMsg = (severity, msg) => {
    setSeverity(severity);
    setBackupMsg(msg);
  };

  const handleBackupWarningMessages = (response) => {
    if (response.hasOwnProperty("data") && response.data.hasOwnProperty('errors')) {
      response.data.errors.forEach(error => {
        handleArchiveMsg(
          "warning",
          error.message
        );
      });
    }
  }

  const handleBackup = async (event) => {
    event.preventDefault();
    const backupUrl = backupFile ? url + "/" + backupFile : url;
    await axios
      .post(
        backupUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        }
      )
      .then(function (response) {
        handleBackupResponse(false, true, true);
        if (backupFile && response.status == 204) {
          handleBackupMsg(
            "success",
            "Backup job started sucessfully for " + backupFile
          );
        } else if (!backupFile && response.status == 204) {
          handleBackupMsg("success", "Backup job started sucessfully!");
        } else if (response.status == 403) {
          handleBackupWarningMessages(response);
        } else {
          handleBackupMsg("error", "Error in creating backup");
        }
        queryClient.invalidateQueries("completebackup");
        return response;
      })
      .catch(function (error) {
        handleBackupResponse(false, true, true);
        queryClient.invalidateQueries("completebackup");
        handleBackupMsg("error", "Error in creating backup");
      });
  };

  const handleDelete = async (event, name) => {
    event.preventDefault();
    const fileName = backupFile;
    try {
      const deleteResp = await axios
        .delete(deleteUrl + "/" + backupFile, {},  {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        })
        .then(function (response) {
          handleBackupResponse(false, true, true);
          if (response && response.status == 204) {
            handleBackupMsg(
              "success",
              "Backup " + fileName + " was successfully deleted "
            );
          } else if (response.status == 403) {
            handleBackupWarningMessages(response);
          } else {
            handleBackupMsg("error", "Error when deleting backup!");
          }
          queryClient.invalidateQueries("completebackup");
          return response;
        })
        .catch(function (error) {
          handleBackupResponse(false, true, true);
          queryClient.invalidateQueries("completebackup");
          handleBackupMsg("error", "Error when deleting backup!");
        });
    } catch (e) {
      setMessage("Error while deleting" + fileName);
      setIsError(true);
    }

    queryClient.invalidateQueries("completebackup");
  };

  const handleRestore = async (event) => {
    const json = JSON.stringify({ file_prefix: restoredFile });
    try {
      const restoreResp = await axios
        .post(restoreUrl + "/" + restoredFile,  {}, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        })
        .then(function (response) {
          handleBackupResponse(false, true, true);
          if (response &&  response.status == 204) {
            handleBackupMsg(
              "success",
              "Restore job started sucessfully for " + restoredFile
            );
          } else if (response.status == 403) {
            handleBackupWarningMessages(response);
          } else {
            handleBackupMsg("error", "Error when restoring backup!");
          }
          queryClient.invalidateQueries("completebackup");
          return response;
        })
        .catch(function (error) {
          handleBackupResponse(false, true, true);
          queryClient.invalidateQueries("completebackup");
          handleBackupMsg("error", "Error when restoring backup!");
        });
    } catch (e) {
      setMessage("Error while restoring" + restoredFile);
      setIsError(true);
    }

    queryClient.invalidateQueries("restore");
  };

  const restoreData = (data) => {
    let tableData = {
      columns: restoreColumns,
      rows: [],
    };

    if (data) {
      if (data.length > 0) {
        tableData.rows = data.map((item) => {
          let status = (
            <Tooltip title="Job Pending" placement="top">
              <PendingIcon fontSize="medium" style={{ position: "relative" }} />
            </Tooltip>
          );

          if ("failed" == item.job_status) {
            status = (
              <Tooltip title="Job Failed" placement="top">
                <FailureIcon
                  fontSize="medium"
                  style={{ color: red[500], position: "relative" }}
                />
              </Tooltip>
            );
          } else if (item.job_status == "running") {
            status = (
              <Tooltip title="Running" placement="top">
                <CircularProgress
                  size={20}
                  style={{ color: green[500], position: "relative" }}
                />
              </Tooltip>
            );
          } else if ("active" == item.job_status) {
            status = (
              <Tooltip title="Job Running" placement="top">
                <CircularProgress
                  size={20}
                  style={{ color: green[500], position: "relative" }}
                />
              </Tooltip>
            );
          } else if ("succeeded" == item.job_status) {
            status = (
              <Tooltip title="Job Completed" placement="top">
                <SuccessIcon
                  fontSize="medium"
                  style={{ color: green[500], position: "relative" }}
                />
              </Tooltip>
            );
          }

          return {
            icon: <RestoreIcon fontSize="medium" />,
            name: item.name ? item.name : "",
            start: item.start_time ? item.start_time : "",
            end: item.end_time,
            status: status,
          };
        });
      }
    }

    return tableData;
  };

  const backupData = (data) => {
    let tableData = {
      columns: columns,
      rows: [],
    };

    if (data && data.items.length > 0) {
      tableData.rows = data.items.map((item) => {
        let status = (
          <Tooltip title="Status Unknown" placement="top">
            <PendingIcon fontSize="medium" style={{ position: "relative" }} />
          </Tooltip>
        );

        if (item.job_status == "failed") {
          status = (
            <Tooltip title="Failed" placement="top">
              <FailureIcon
                fontSize="medium"
                style={{ color: red[500], position: "relative" }}
              />
            </Tooltip>
          );
        } else if (item.job_status == "running") {
          status = (
            <Tooltip title="Running" placement="top">
              <CircularProgress
                size={20}
                style={{ color: green[500], position: "relative" }}
              />
            </Tooltip>
          );
        } else if (item.job_status == "succeeded") {
          status = (
            <Tooltip title="Succeeded" placement="top">
              <SuccessIcon
                fontSize="medium"
                style={{ color: green[500], position: "relative" }}
              />
            </Tooltip>
          );
        }

        return {
          name1: item.name,
          name: item.name ? (
            <Link to={"backup/" + item.name.replace("/", "")}>
              {item.name.replace("/", "")}
            </Link>
          ) : (
            ""
          ),
          size: item.size ? <PrettyBytes bytes={item.size} /> : "",
          status: status,
          lastsync: item.last_sync ? item.last_sync : "",
          delete: item.name ? (
            <DeleteButton name={item.name.replace("/", "")} />
          ) : (
            ""
          ),
          restore:
            item.job_status == "succeeded" ? (
              <RestoreButton name={item.name.replace("/", "")} />
            ) : (
              <RestoreDisableButton />
            ),
          update: item.name ? (
            <CatchUpButton
              status={item.job_status}
              name={item.name.replace("/", "")}
            />
          ) : (
            ""
          ),
        };
      });
      
    }

    return tableData;
  };

  const openRestorePopover = (event) => {
    setAnchorElPop(event.currentTarget);
  };

  const closeRestorePop = (event) => {
    setAnchorElPop(null);
  };

  const openDeletePopover = (event) => {
    setDeleteElPop(event.currentTarget);
  };

  const closeDeletePop = (event) => {
    setDeleteElPop(null);
  };

  const openCatchUpPopover = (event) => {
    setBackupElPop(event.currentTarget);
  };

  const closeCatchUpPop = (event) => {
    setBackupFile("");
    setBackupElPop(null);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          marginBottom: "20px",
        }}
      >
        <div>
          <label htmlFor="backup">
            <Button
              className="btn-choose"
              component="span"
              color="danger"
              size="medium"
              onClick={(event) => {
                event.preventDefault();
                setBackupFile("");
                createBackUp(event);
              }}
              disabled={!nfsStatus || isCreatingBackup}
            >
              Back up now &nbsp;
            </Button>
          </label>
        </div>
        <div style={{ width: "100%" }}>
          <MDBox
            ml={10}
            mt={0.5}
            mb={2}
            style={{
              padding: "10px",
              background: "#fff",
              border: "1px solid #dcdcdc",
            }}
          >     
             { nfsStatus ?
              <Box><b>NFS File Share :</b>  {nfsStatus}  </Box> :  
              <Box><b>Backup disabled :</b> There is no NFS file share currently enabled.  </Box>
              }
          </MDBox>
          {(error || backupResponse) && (
            <Box ml={10} mt={1} mb={2} style={{ marginBottom: "20px" }}>
              <Collapse in={open}>
                <Alert
                  severity={severity}
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                  sx={{ mb: 2 }}
                >
                  {backupMsg}
                </Alert>
              </Collapse>
            </Box>
          )}
        </div>
      </div>
      {isLoading && (
        <CircularProgress
          size={24}
          style={{ marginLeft: "45%", position: "relative", top: 4 }}
        />
      )}

      <Dialog
        open={openRestorePop}
        onClose={closeRestorePop}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Restore of Backup"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Restoring from a backup will result in application downtime during
            the restore process. Your current data will be lost and be replaced
            by the backup data. Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRestorePop} color="primary">
            No
          </Button>
          <Button
            onClick={() => {
              handleRestore();
              closeRestorePop();
            }}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCatchUpPop}
        onClose={closeCatchUpPop}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{label}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {catchUpDesc}
            Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCatchUpPop} color="primary">
            No
          </Button>
          <Button
            onClick={(e) => {
              handleBackup(e, "");
              closeCatchUpPop();
            }}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeletePop}
        onClose={closeDeletePop}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Backup"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This action is final! Once the backup is deleted, it cannot be
            restored. Deleting a previous backup will free up space on your
            backup location. Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeletePop} color="primary">
            No
          </Button>
          <Button
            onClick={(e) => {
              handleDelete(e, "");
              closeDeletePop();
            }}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <DataTable
        tableTitle="Restore Status"
        table={nfsStatus ? restoreData( (restoreResult.data && restoreResult.data.hasOwnProperty('items'))? restoreResult.data.items: []) : restoreData("")}
        canSearch={false}
        showTotalEntries={false}
        isSorted={false}
        noEndBorder
        entriesPerPage={false}
      />

      <Divider variant="middle" />

      <DataTable
        tableTitle="Backups Records"
        table={nfsStatus ? backupData(data) : backupData("")}
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        initialSortField="last_sync"
        initialSortDesc={true}
        noEndBorder
        entriesPerPage={true}
        hiddenCols={"name1"}
      />
    </React.Fragment>
  );
}
